export const REDACTED = '[REDACTED]';
export const REDACTED_DEPTH = '[REDACTED_DEPTH]';
export const CIRCULAR = '[Circular]';

export const MAX_DEPTH = 8;

export const SENSITIVE_KEY_FRAGMENTS: ReadonlyArray<string> = [
  'password', 'senha', 'secret', 'token', 'authorization', 'apikey', 'accesskey', 'privatekey',
  'jwt', 'cookie', 'cvv', 'cvc', 'cardnumber', 'cardcvv', 'creditcard', 'cpf', 'cnpj',
  'encryptionkey', 'document', 'username', 'email', 'phone', 'otp', 'address', 'birth', 'qrcode',
  'copiaecola', 'receipthandle', 'bankaccount', 'expmonth', 'expyear', 'sixdigits',
  'diagnosis', 'diagnostico',
];

export const NEVER_REDACTED_PATHS: ReadonlySet<string> = new Set(['user.id', 'usr.id', 'session_id']);

export const NEVER_REDACTED_KEYS: ReadonlySet<string> = new Set(['cep', 'zipcode']);

export const SENSITIVE_SUBTREE_PATHS: ReadonlyArray<string> = [
  'requestConfig.data',
  'requestConfig.headers',
  'response.data',
  'response.body',
  'operation.variables',
];

export const STRING_PATTERNS: ReadonlyArray<readonly [RegExp, string]> = [
  [/\b\d{3}\.\d{3}\.\d{3}-\d{2}\b/g, '[REDACTED_CPF]'],
  [/\b\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}\b/g, '[REDACTED_CNPJ]'],
  [/\b[A-Za-z0-9_-]{10,}\.[A-Za-z0-9_-]{10,}\.[A-Za-z0-9_-]{10,}\b/g, '[REDACTED_JWT]'],
  [/((?:cpf|documento)[\s\S]{0,20}?)\b\d{11}\b/gi, '$1[REDACTED_CPF]'],
  [/\b\d{11}\b(?=[\s\S]{0,20}?(?:cpf|documento))/gi, '[REDACTED_CPF]'],
  [/((?:token|access_token|password|pin)=)[^&#\s'"]+/gi, '$1[REDACTED]'],
  [/[\w.+-]+@[\w-]+\.[\w.-]+/g, '[REDACTED_EMAIL]'],
];
